// Shared product display helpers

// "₹ 1,599" (space after the symbol, Indian digit grouping), as on the cards
export const formatPrice = (value, { space = true } = {}) =>
    `₹${space ? ' ' : ''}${Number(value || 0).toLocaleString('en-IN')}`;

// Products store a free-text colour ("Olive Check", "Sky Blue"); map it to a swatch fill
const SWATCHES = [
    ['indigo', '#2E3A59'], ['navy', '#1F2A44'], ['sky', '#8EC5E8'], ['light blue', '#A9C8E8'], ['blue', '#3B6FB6'],
    ['black', '#111111'], ['white', '#FFFFFF'], ['grey', '#9CA3AF'], ['gray', '#9CA3AF'], ['charcoal', '#36454F'],
    ['khaki', '#C3B091'], ['beige', '#E3D3B5'], ['camel', '#C19A6B'], ['cream', '#F3EBD8'], ['brown', '#6F4E37'],
    ['rust', '#B7410E'], ['red', '#C0392B'], ['maroon', '#7B1E2B'], ['olive', '#6B7B3A'], ['green', '#3C7A4E'],
    ['lavender', '#B9A9DA'], ['pink', '#E8A0B4'], ['yellow', '#E8C547'], ['orange', '#E8833A'], ['check', '#8D8D7A'],
];

export const swatchColor = (colorName = '') => {
    const name = colorName.toLowerCase();
    const hit = SWATCHES.find(([key]) => name.includes(key));
    return hit ? hit[1] : '#BDBDBD';
};

export const productPath = (product) => `/product/${product._id}`;
